// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { differenceInHours as fn } from "../differenceInHours.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const differenceInHoursWithOptions = convertToFP(fn, 3);

// Fallback for modularized imports:
export default differenceInHoursWithOptions;
